import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './PanelHeader.scss';
import { Component } from 'react';
/**
 * Returns a panel header with a title that renders provided children
 *
 * @category Components
 */
export class PanelHeader extends Component {
    render() {
        return _jsxs(LL_H_C, { className: 'panel-header', children: [_jsx("span", { className: 'panel-header__title', children: this.props.title }), this.props.children] });
    }
}
//# sourceMappingURL=PanelHeader.js.map